import React from 'react';

const FilterContext = React.createContext({
    agency: undefined,
    filters: undefined,
    shapes: undefined
});

export const FilterProvider = FilterContext.Provider;

export default FilterContext;
